import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

//
import Input from "../input/Input";
import Button from "../button/Button";
import Textarea from "../textarea/Textarea";

export default function ContactForm({ bg = "--bg" }) {
  const { t } = useTranslation();

  return (
    <StyledContactForm $bg={bg}>
      <h2>{t("mainContactFormTitle")}</h2>
      <Input
        type="text"
        label={t("mainContactFormName")}
        placeholder={t("mainContactFormNamePlaceholder")}
        id="homeContactName"
      />
      <Input
        type="phone"
        label={t("mainContactFormPhone")}
        placeholder={t("mainContactFormPhonePlaceholder")}
        id="homeContactPhone"
      />
      <Textarea
        label={t("mainContactFormMsg")}
        placeholder={t("mainContactFormMsgPlaceholder")}
        id="homeContactMsg"
      />
      <Button>{t("mainContactFormBtn")}</Button>
    </StyledContactForm>
  );
}

const StyledContactForm = styled.div`
  background-color: var(${(props) => props.$bg});
  padding: 60px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  border: 1px solid var(--border);

  h2 {
    color: var(--title);
    font-size: var(--fs-card-title);
    font-style: normal;
    font-weight: var(--fw-semibold);
    line-height: 1.35;
  }
`;
